import bshgenAPI from '../bshgenAPI'

export const getLogs = async (brand) => {
  return await bshgenAPI(`logs/${brand}`)
}

export const uploadFiles = async (brand, files, overwrite) => {
  return await bshgenAPI(`upload/${brand}`, {
    method: 'POST',
    data: { overwrite },
    files,
  })
}
